/**
 * @generated SignedSource<<6c484b9adf713949d83315b0dd85f269>>
 * @relayHash 75be12b53dd01410c4142782c2178a15
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 75be12b53dd01410c4142782c2178a15

import { ConcreteRequest } from 'relay-runtime';
export type useRemoveAllAppointmentsMutationAndTheirChEpisodeOfCareRelatedDataMutation$variables = Record<PropertyKey, never>;
export type useRemoveAllAppointmentsMutationAndTheirChEpisodeOfCareRelatedDataMutation$data = {
  readonly ch_removeAllEpisodeOfCareRelatedData: {
    readonly boolean: boolean | null;
  };
};
export type useRemoveAllAppointmentsMutationAndTheirChEpisodeOfCareRelatedDataMutation = {
  response: useRemoveAllAppointmentsMutationAndTheirChEpisodeOfCareRelatedDataMutation$data;
  variables: useRemoveAllAppointmentsMutationAndTheirChEpisodeOfCareRelatedDataMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Ch_removeAllEpisodeOfCareRelatedDataPayload",
    "kind": "LinkedField",
    "name": "ch_removeAllEpisodeOfCareRelatedData",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "boolean",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useRemoveAllAppointmentsMutationAndTheirChEpisodeOfCareRelatedDataMutation",
    "selections": (v0/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useRemoveAllAppointmentsMutationAndTheirChEpisodeOfCareRelatedDataMutation",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "id": "75be12b53dd01410c4142782c2178a15",
    "metadata": {},
    "name": "useRemoveAllAppointmentsMutationAndTheirChEpisodeOfCareRelatedDataMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "e6fe16251154847fbbc2a518cb8b50e0";

export default node;
